import { withInstall } from '../../utils/install';
import Checkbox from './index.vue';

export const IvueCheckbox = withInstall(Checkbox);
export default IvueCheckbox;

export * from './index.vue';
